import { render, staticRenderFns } from "./VehicleView.vue?vue&type=template&id=021a5778"
import script from "./VehicleView.vue?vue&type=script&lang=js"
export * from "./VehicleView.vue?vue&type=script&lang=js"
import style0 from "./VehicleView.vue?vue&type=style&index=0&id=021a5778&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021a5778')) {
      api.createRecord('021a5778', component.options)
    } else {
      api.reload('021a5778', component.options)
    }
    module.hot.accept("./VehicleView.vue?vue&type=template&id=021a5778", function () {
      api.rerender('021a5778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vehicle/VehicleView.vue"
export default component.exports